import { cn } from 'lib/utils'

import type { AssetName } from '../hooks/useAssetNames'
import type { EntityRef } from '../types/presentation.types'
import { SCOPE_OPTIONS } from './AssetPicker'

/**
 * The asset a story is about, as a small chip (MYD-495). Names come from
 * `useAssetNames`; one the viewer cannot see reads "Not available", which is
 * exactly what its blocks will show.
 */
export function AnchorChip({ anchor, name, className }: { anchor: EntityRef | null; name: AssetName | null; className?: string }) {
	if (!anchor) return <span className={cn('text-[11px] text-muted-foreground', className)}>No asset</span>

	const option = SCOPE_OPTIONS.find(candidate => candidate.scope === anchor.scope)
	const Icon = option?.icon
	const label = name === 'missing' ? 'Not available' : name === 'loading' || !name ? option?.label ?? anchor.scope : name.name

	return (
		<span
			className={cn(
				'inline-flex max-w-full items-center gap-1 rounded-full bg-primary/5 px-2 py-0.5 text-[11px] font-medium text-primary',
				name === 'missing' && 'bg-gray-100 text-gray-500',
				className,
			)}
			title={label}
		>
			{Icon && <Icon className="h-3 w-3 shrink-0" />}
			<span className="truncate">{label}</span>
		</span>
	)
}

export default AnchorChip
